/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceDraftMergeOperations } from "./SpaceDraftMergeOperations";
export const SpaceDraftMergeOperationsResponse = core.serialization.object({
    data: SpaceDraftMergeOperations,
});
